import { formatFocusedImage } from "./formatBaseMolecules"
import formatPageLinks from "./formatPageLinks"


const dotenv = require("dotenv")
dotenv.config()
const formatProductIntroCard = (
  data,
  locale = "en",
  location,
  appData = null,
  region,
  ratio = null,
  homepageSlug,
  currentSpaceId
) => {
  if (data && Array.isArray(data)) {
    return data?.map(card => {
      let hasImage = false
      let isContentfulImage = false
      if (
        card?.productImage?.image?.file?.url ||
        card?.form?.sections?.[0]?.product?.media?.[0]?.image?.file?.url
      ) {
        hasImage = true
      }

      if (
        card?.media?.[0]?.__typename ===
          "ContentfulImage" ||
        card?.productImage?.__typename === "ContentfulImage"
      ) {
        isContentfulImage = true
      }

      return {
        logo: card?.logo?.brandfolderAsset?.[0]?.url
            ? {
                altText: card?.logo?.altText,
                url: card?.logo?.brandfolderAsset?.[0]?.url,
              }
            :  card?.logo?.image?.file
          ? {
              altText: card?.logo?.image?.altText,
              url: card?.logo?.image?.file?.url,
            }
          : null,

        productName: card?.internalTitle
          ? card?.internalTitle
          : null,
        header: card?.title || null,
        subheader: card?.shortDescription || null,
        image: {
              altText:
                card?.media?.[0]?.image?.altText,
              url: card?.media?.[0]?.image?.file
                ?.url,
            },
        body: card?.longDescription?.childMarkdownRemark?.html,
        cardLink:
        card?.productPage ?
          card?.productPage?.__typename === "ContentfulProductPage"
          ? formatPageLinks(
            {
              url: {url: `${card?.productPage?.url}`},
              text: card?.productPage?.url && "Get a Demo"
            }, 
            locale, 
            "ContentfulProductPage", 
            homepageSlug,
            currentSpaceId
          )
          : 
          card?.productPage?.__typename === "ContentfulPageBase" ?
          formatPageLinks(
            {
              url: {url: `${card?.productPage?.url}`},
              text: card?.productPage?.url && "Learn More"
            }, 
            locale, 
            "ContentfulPageBase", 
            homepageSlug,
            currentSpaceId
          )
          : card?.productPage?.__typename === "ContentfulExternalLink" 
          ? {
            
            url: card?.productPage?.url || null,
            text: card?.productPage?.url && "Learn More",
          }
          : null
        : null,
        viewMoreText: appData?.viewMoreLabel
          ? appData?.viewMoreLabel
          : "View More",
        viewLessText: appData?.viewLessLabel
          ? appData?.viewLessLabel
          : "View Less",
      }
    })
  }
}

export default formatProductIntroCard;